//
// DownloadManager.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../lib";
import "./warnings/TransportWarning";

var DownloadManager = createModule("transport::DownloadManager", [], EventDispatcher, [
    {
        DOWNLOAD_STARTED: 60003,
        DOWNLOAD_CANCELLED: 60005,
        DOWNLOADS_FINISHED_ABNORMALLY: 60006,
        INVALID_REPORT: 60000,
        REPORT_DOWNLOAD_LIMIT_EXCEEDED: 60002,
        DOWNLOAD_IN_PROGRESS: 60001,
        DOWNLOAD_FAILED: 60004,
    },
    ,
    ,
    ,
    {
        resume: [1,1],
        cancel: [1,1],
        cancelAll: [1],
        pauseAll: [1],
        resumeAll: [1],
        start: [1,1],
        pause: [1,1],
    },
    ,
    ,
]);
export default DownloadManager;
